import React from 'react';
import { Typography, TextField, FormControlLabel, Checkbox } from '@mui/material';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { useEffect } from 'react';
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import ComponentHeaderTitles from '../ComponentHeaderTitles';
import { MuiTelInput } from 'mui-tel-input'
import { isValidPhoneNumber } from 'react-phone-number-input';

// import TextFieldPhoneInput from './TextFieldPhoneInput';
const ContactGegevens = ({
    onUpdateValidationErrors,
    telefoonnummer,
    setTelefoonnummer,
    email,
    setEmail,
}) => {

    const [telefoonnummerState, setTelefoonnummerState] = React.useState();
    const [telefoonnummerError, setTelefoonnummerError] = React.useState(false);
    const [emailError, setEmailError] = React.useState(false);
    const handleTelefoonnummerChange = (value) => {
        if (value != undefined && value.startsWith('+31')) {
            // effectively makes sure that the user can't remove the NL country code
            setTelefoonnummer(value);
            setTelefoonnummerState(value);
            setTelefoonnummerError(false);
        } else {
            // set to +31
            setTelefoonnummer('+31');
            setTelefoonnummerState('+31');
        }
    };

    

    /**
     * Empty the validation errors when there is no email or telefoonnummer error,
     * otherwise set the validation errors in the parent component.
     * Depends on a change in emailError or telefoonnummerError, so will not 
     * apply on mount.
     */
    useEffect(() => {
        if (!emailError && !telefoonnummerError) {
            onUpdateValidationErrors([]);
        } else {
            // If we have local errors, we want to set the validation errors in the parent component.
            telefoonnummerError && onUpdateValidationErrors(['Gelieve een geldig telefoonnummer in te vullen', false]);
            emailError && onUpdateValidationErrors(['Gelieve een geldig email adres in te vullen', false]);
        }

    }, [emailError, telefoonnummerError]);


    function validateEmailFormat() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return 'Gelieve een geldig emailadres in te vullen'; // "Please enter a valid email address"
        }
        return true;
    };

    const handleEmailadresChange = (event) => {
        const value = event.target.value;
        setEmail(value);
    };

    const handleEmailadresBlur = (event) => {
        const value = event.target.value;
        setEmail(value);
        const emailValidation = validateEmailFormat(email);
        if (emailValidation == true) {
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    }

    const handleTelefoonnummerBlur = (event) => {
        const value = event.target.value;
        setTelefoonnummer(value);
        if (isValidPhoneNumber(value)) {
            setTelefoonnummerError(false);
        } else {
            setTelefoonnummerError(true);
        }
    }


    /**
     * If the user has already filled in the kvkNummer or geboorteDatum, this will be set in the parent state.
     * But if the user goes back a step, then comes back here, the local errors state will be empty and as such,
     * the continue button will be enabled. So we need to check if the user has already filled in the kvkNummer or
     * geboorteDatum and if so, we need to validate them.
     */
    useEffect(() => {
        if (telefoonnummer) {
            handleTelefoonnummerBlur ({ target: { value: telefoonnummer } });
            setTelefoonnummerState(telefoonnummer);
        }
        if (email) {
            handleEmailadresBlur ({ target: { value: email } });
        }
    }, []);


    return (
        <div>
            <ComponentHeaderTitles title="Hoe kunnen we je bereiken?" />
            <Typography variant="body2" color="textSecondary">
                Als we vragen hebben over je aanmelding, nemen we contact met je op.
            </Typography>

            <div className="telefoonnummer">
                <Typography variant="subtitle1" color="textPrimary">
                    <b>Telefoonnummer</b>
                </Typography>
                <MuiTelInput
                    placeholder="Telefoonnummer"
                    // type="text"
                    value={telefoonnummerState}
                    onChange={handleTelefoonnummerChange}
                    onBlur={handleTelefoonnummerBlur}
                    defaultCountry="NL"
                    onlyCountries={['NL']}
                    disableDropdown={true}
                    disableCountryCode={true}
                    error={telefoonnummerError}
                    helperText={telefoonnummerError && 'Gelieve een geldig telefoonnummer in te vullen'}
                />
                <Typography variant="subtitle2" color="textSecondary">
                    We geven je telefoonnummer natuurlijk niet door aan derden.
                </Typography>
            </div>

            <div className="emailadres">
                <Typography variant="subtitle1" color="textPrimary">
                    <b>E-mailadres</b>
                </Typography>
                <TextField
                    placeholder="E-mailadres"
                    type="email"
                    value={email}
                    error={emailError}
                    helperText={emailError && 'Gelieve een geldig emailadres in te vullen'}
                    onBlur={handleEmailadresBlur}
                    onChange={handleEmailadresChange}
                />
                <Typography variant="body2" color="textSecondary">
                    Je ontvangt op dit adres de bevestiging van je bestelling en je contract.
                </Typography>
            </div>
        </div>
    );
};

ContactGegevens.displayName = 'ContactGegevens';
export default ContactGegevens;
